export const categories = [
  { slug: "film", name: "电影作品", icon: "ri-movie-2-line", description: "苍井优在大银幕上的精彩演绎" },
  { slug: "drama", name: "电视剧", icon: "ri-tv-line", description: "小荧幕中的动人表演" },
  { slug: "stage", name: "舞台剧", icon: "ri-building-2-line", description: "现场演出的独特魅力" },
  { slug: "awards", name: "获奖经历", icon: "ri-award-line", description: "荣誉与认可的见证" },
  { slug: "biography", name: "个人资料", icon: "ri-user-smile-line", description: "了解真实的苍井优" },
  { slug: "news", name: "最新动态", icon: "ri-flashlight-line", description: "苍井优的最新消息与动态" },
];

export const categoryMap: Record<string, string> = {
  film: "电影作品",
  drama: "电视剧",
  stage: "舞台剧",
  awards: "获奖经历",
  biography: "个人资料",
  news: "最新动态",
};